/* Stylesheet */

.dev_mode_toggle {
  padding: 0px 21px 0px 21px;
  display: flex;
  align-items: center;
  height: 48px;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 42px;
  box-shadow: var(--ion-box-shadow);

  span {
    font-weight: 500;
  }

  .toggle {
    --handle-background: #e7edf7;
    --handle-background-checked: var(--ion-color-primary);
    --track-background: #f6f8fc;
  }
}
